import React from 'react';
import FriendsComponent from './components/Friends';
import VideoComponent from './components/Video';
import AudioComponent from './components/Audio';
import CheckListComponent from './components/CheckList';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Form, Input, Row, Col, Label, Button, FormGroup } from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const handleWarning = (type) => {
  return MySwal.fire({
    title: 'Error!',
    text: `Por favor carga ${type} antes de continuar.`,
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    buttonsStyling: false
  });
};

function ActivityTypeComponent({
  defaultValues,
  handleChangeType,
  type,
  editMode,
  handleOnSubmit,
  stepper
}) {
  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    if (type === 'form') {
      handleOnSubmit(values);
      stepper.next();
    } else if (type === 'audio') {
      if (!values.cover) {
        handleWarning('una portada');
        return;
      }
      if (!values.audio) {
        handleWarning('un audio');
        return;
      }
      handleOnSubmit(values, true);
    } else {
      handleOnSubmit(values, true);
    }
  };

  return (
    <div className="mt-2">
      <Formik
        initialValues={{
          ...defaultValues,
          type
        }}
        validate={(values) => {
          const errors = {};
          if (values.status === 'initial') {
            errors.status = 'Invalid';
          }
          return errors;
        }}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <Row lg={12} className="mb-1">
              <Col>
                <Label htmlFor="type" className="label-road-input">
                  Tipo
                </Label>
                <Input
                  type="select"
                  name="type"
                  id="type"
                  onChange={(e) => {
                    handleChangeType(e.target.value);
                    handleChange(e);
                  }}
                  placeholder={type}
                  onBlur={handleBlur}
                  value={values.type}
                  disabled={editMode}
                  required
                >
                  <option disabled value={'initial'}>
                    Seleccionar Tipo
                  </option>
                  <option value="form">Formulario</option>
                  <option value="video">Video</option>
                  <option value="audio">Audio</option>
                  <option value="friends">Amigos</option>
                  <option value="checklist">CheckList</option>
                </Input>
              </Col>

              <Col>
                <Label htmlFor="name" className="label-road-input">
                  Nombre
                </Label>
                <Input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Nombre de la actividad"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  required
                />
              </Col>
              <Col>
                <Label htmlFor="description" className="label-road-input">
                  Descripcion
                </Label>
                <Input
                  type="text"
                  name="description"
                  id="description"
                  placeholder="Descripcion de la actividad"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                  required
                />
              </Col>
              <Col>
                <Label htmlFor="status" className="label-road-input">
                  Estado
                </Label>
                <Input
                  type="select"
                  name="status"
                  id="status"
                  placeholder="Seleccionar Estado"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.status}
                  required
                >
                  <option disabled value={'initial'}>
                    Seleccionar Estado
                  </option>
                  <option value={true}>Activo</option>
                  <option value={false}>Inactivo</option>
                </Input>
              </Col>
            </Row>

            {(() => {
              switch (type) {
                case 'friends':
                  return (
                    <FriendsComponent
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                    />
                  );

                case 'video':
                  return (
                    <VideoComponent
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                    />
                  );
                case 'audio':
                  return (
                    <AudioComponent
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                    />
                  );
                case 'checklist':
                    return (
                      <CheckListComponent
                        values={values.list ?? []}                      
                        setFieldValue={setFieldValue}                       
                      />
                  );  
                default:
                  return null;
              }
            })()}

            <Row>
              <Col lg={10} />
              <Col
                lg={2}
                className="d-flex justify-content-end align-items-end"
              >
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  color="success"
                  className="mt-1 w-100"
                >
                  {editMode
                    ? type === 'form'
                      ? 'Siguiente'
                      : 'Guardar'
                    : type === 'form'
                    ? 'Siguiente'
                    : 'Crear'}
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

ActivityTypeComponent.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  handleChangeType: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  editMode: PropTypes.bool.isRequired
};

export default ActivityTypeComponent;
